<template>
    <div>
        <b-card-title class="text-dark font-20 font-weight-bold"
            ><b-row>
                <b-col>Thống kê thiệt hại về tài sản </b-col>
                <b-col class="text-right">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm dữ liệu thiệt hại về tài sản</span>
                    </b-button>
                </b-col>
            </b-row>
        </b-card-title>
        <b-table
            class="mt-2"
            striped
            hover
            :items="listAssetDamage"
            :fields="assetsFields"
            show-empty
            :current-page="currentPage"
            :per-page="CONSTANTS.ITEM_PER_PAGE"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-compare="myCompare"
        >
            <template #cell(index)="data">{{
                (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
            }}</template>
            <template v-slot:cell(traffic)="row">
                {{ row.item.data.traffic }}
            </template>
            <template v-slot:cell(construction)="row">
                {{ row.item.data.construction }}
            </template>
            <template v-slot:cell(agriculture)="row">
                {{ row.item.data.agriculture }}
            </template>
            <template v-slot:cell(irrigation)="row">
                {{ row.item.data.irrigation }}
            </template>
            <template v-slot:cell(electricity)="row">
                {{ row.item.data.electricity }}
            </template>
            <template v-slot:cell(total)="row">
                {{ row.item.data.total }}
            </template>
            <template #cell(actions)="row">
                <b-button
                    variant="primary"
                    class="mr-1 min-width-none"
                    @click="showUpdateModal(row.item.id)"
                    v-b-tooltip.hover
                    :title="$t('common.edit')"
                >
                    <i class="fa fa-pencil"></i>
                </b-button>
                <b-button
                    variant="danger"
                    @click="confirmDelete(row.item.id)"
                    v-b-tooltip.hover
                    class="min-width-none"
                    :title="$t('common.delete')"
                >
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
            <template v-slot:empty>
                <div class="text-center">
                    <span>Không có bản ghi nào</span>
                </div>
            </template>
        </b-table>
        <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
            <b-pagination
                v-model="currentPage"
                :total-rows="countRow"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
                :hide-goto-end-buttons="true"
                :prev-text="$t('common.prevPage')"
                :next-text="$t('common.nextPage')"
                class="my-0"
                align="center"
            ></b-pagination>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${$t('common.create')}`"
            :title="`${'Thêm dữ liệu thiệt hại'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
        >
            <b-form-group label="Thời gian">
                <RDateTimePicker
                    @updateValue="onChangeDate"
                    :type="'date'"
                    placeholder="Nhập thời gian"
                />
            </b-form-group>
            <b-form-group label="Giao thông">
                <b-form-textarea
                    v-model="itemInfo.data.traffic"
                    maxlength="255"
                    rows="3"
                    placeholder="Nhập thông tin"
                />
            </b-form-group>
            <b-form-group label="Về nhà cửa, công trình kiến trúc">
                <b-form-textarea
                    v-model="itemInfo.data.construction"
                    maxlength="255"
                    rows="3"
                    placeholder="Nhập thông tin"
                />
            </b-form-group>
            <b-form-group label="Về nông nghiệp">
                <b-form-textarea
                    v-model="itemInfo.data.agriculture"
                    maxlength="255"
                    rows="3"
                    placeholder="Nhập thông tin"
                />
            </b-form-group>
            <b-form-group label="Công trình thủy lợi, nước sinh hoạt">
                <b-form-textarea
                    v-model="itemInfo.data.irrigation"
                    maxlength="255"
                    rows="3"
                    placeholder="Nhập thông tin"
                />
            </b-form-group>
            <b-form-group label="Hệ thống điện, cáp quang">
                <b-form-textarea
                    v-model="itemInfo.data.electricity"
                    maxlength="255"
                    rows="3"
                    placeholder="Nhập thông tin"
                />
            </b-form-group>
            <b-form-group label="Tổng thiệt hại">
                <b-form-input
                    v-model="itemInfo.data.total"
                    maxlength="255"
                    placeholder="Nhập số liệu"
                />
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn xoá dữ liệu này?</b-modal
        >
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import RDateTimePicker from '@/components/RDateTimePicker';
import CONSTANTS from '@/constants';
export default {
    components: {
        RDateTimePicker
    },
    data() {
        return {
            assetsFields: [
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'index',
                    label: '#'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'date',
                    label: 'Trận lũ',
                    sortable: true
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'traffic',
                    label: 'Giao thông'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'construction',
                    label: 'Về nhà cửa, công trình kiến trúc'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'agriculture',
                    label: 'Về nông nghiệp'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'irrigation',
                    label: 'Công trình thủy lợi, nước sinh hoạt'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'electricity',
                    label: 'Hệ thống điện, cáp quang'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'align-middle',
                    key: 'total',
                    label: 'Tổng thiệt hại'
                },
                {
                    thClass: 'fixed-actions-col align-middle',
                    tdClass: 'align-middle',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            sortBy: 'date',
            sortDesc: false,
            itemInfo: {
                data: {}
            },
            CONSTANTS,
            currentPage: 1,
            currentId: null
        };
    },
    computed: {
        ...mapState({
            damageInfo: (state) => state.analyze.damageInfo,
            listDamages: (state) => state.analyze.listDamages
        }),
        countRow() {
            return this.listAssetDamage.length;
        },
        listAssetDamage() {
            return this.listDamages.filter((item) => item.type === 'ASSET');
        }
    },
    methods: {
        ...mapActions({
            updateOrCreate: 'analyze/updateOrCreate',
            deleteById: 'analyze/delete',
            getDamageInfo: 'analyze/getDamageInfo'
        }),
        myCompare(itemA, itemB, key) {
            let a = itemA[key];
            let b = itemB[key];
            a = a.split('/');
            b = b.split('/');
            a = parseInt(a[2], 10) * 10000 + parseInt(a[1], 10) * 100 + parseInt(a[0]);
            b = parseInt(b[2], 10) * 10000 + parseInt(b[1], 10) * 100 + parseInt(b[0]);
            return a - b;
        },
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.itemInfo.type = 'ASSET';
            if (this.itemInfo.id) {
                this.update();
            } else {
                this.add();
            }
            this.$refs.createOrUpdateModal.hide();
            this.$toaster.success(
                `${
                    this.itemInfo.id ? this.$i18n.t('common.update') : this.$i18n.t('common.create')
                } dữ liệu thành công`
            );
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        resetForm() {
            this.itemInfo = {
                data: {}
            };
        },
        async showUpdateModal(id) {
            this.resetForm();
            await this.getDamageInfo({ id: id });
            this.itemInfo = { ...this.damageInfo };
            this.$refs.createOrUpdateModal.show();
        },
        async add() {
            delete this.itemInfo.id;
            await this.updateOrCreate(this.itemInfo);
        },
        async update() {
            await this.updateOrCreate(this.itemInfo);
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (
                this.listAssetDamage.length / this.CONSTANTS.ITEM_PER_PAGE ===
                this.currentPage - 1
            ) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá tin tức thành công!');
        },
        async confirmDelete(id) {
            this.currentId = id;
            this.$refs.deleteModal.show();
        },
        onChangeDate(data) {
            this.itemInfo.date = this.$moment(data).format('DD/MM/YYYY');
        }
    }
};
</script>